import { FC, useMemo } from 'react';
import TagCategoryPanel from './TagCategoryPanel';
import { THandleOpenAssociationDialog, TTag } from '../types';
import { TJurisdictionMap } from '@modules/items';

type TProps = {
  tagsData: TTag[];
  selectedFolderIds: string[];
  jurisdictionsMap: TJurisdictionMap;
  handleOpenAssociationDialog: THandleOpenAssociationDialog;
};

const TagCategoriesList: FC<TProps> = ({
  tagsData,
  selectedFolderIds,
  jurisdictionsMap,
  handleOpenAssociationDialog,
}) => {
  // Group by category
  const groupedByCategory = useMemo(() => {
    const map: Record<string, any[]> = {};
    tagsData.forEach((tag) => {
      const cat = tag.category || 'Uncategorized';
      if (!map[cat]) map[cat] = [];
      map[cat].push(tag);
    });
    return map;
  }, [tagsData]);

  return (
    <div className="flex flex-col gap-8 pt-3">
      {Object.keys(groupedByCategory).map((category) => {
        return (
          <TagCategoryPanel
            key={category}
            categoryName={category}
            tags={groupedByCategory[category]}
            jurisdictionsMap={jurisdictionsMap}
            selectedFolderIds={selectedFolderIds}
            handleOpenAssociationDialog={handleOpenAssociationDialog}
          />
        );
      })}
    </div>
  );
};

export default TagCategoriesList;
